$(document).foundation();

$('#searchButton').click(function() {
  $(this).toggleClass("on");
  $('.search-form').slideToggle();
});

$(document).ready(function(){
  $('.menu-open').click(function(){
    $('nav .menu').toggleClass('show-nav');
  });
  
  
  $('nav .menu>li.drop>a').click(function(e){
    //console.log($(window).width());
    if ($(window).width() < (1007)) {
      e.preventDefault();
      $($($(this)[0]).parent().find('div:first')[0]).toggleClass('show-nav-item');
      return false;
    }
    else {
      return true;
    }
  });
  
  
  
$(window).resize(function() {
  if ($(window).width() < 768) {
     $('.template-product .product-info__title').insertAfter('.breadcrumb');
  }
 else {
    $('.template-product .product-info__title').prependTo('#AddToCartForm');
 }
});  
  
});